import { HttpEventType } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CompaniesService } from 'src/app/services/company.service';
import { CompanyFilesService } from 'src/app/services/company-files.service';
import { GlobalStoreService } from 'src/app/services/global-store.service';
import { ToastService } from 'src/app/services/toast.service';
import { RouterModule } from '@angular/router';
import { KeeniconComponent } from '../../keenicon/keenicon.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-create-loading-files-drawer',
	templateUrl: './create-loading-files-drawer.component.html',
	styleUrls: ['./create-loading-files-drawer.component.scss'],
	imports: [CommonModule, TranslateModule, RouterModule, KeeniconComponent],
	standalone: true,
})
export class CreateLoadingFilesDrawerComponent implements OnInit {
	private _subscriptions: Subscription[] = [];
	activeCompany: any;
	uploadProgress$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	files: any;

	private companiesService = inject(CompaniesService);
	private companyFilesService = inject(CompanyFilesService);
	private globalStoreService = inject(GlobalStoreService);
	private toastService = inject(ToastService);
	constructor() {
		this._subscriptions.push(
			this.companiesService.company$.subscribe({
				next: (res) => {
					if (res && res?.uuid) {
						this.activeCompany = res;
					}
				},
				error: (err) => {},
				complete: () => {},
			})
		);
		this._subscriptions.push(
			this.globalStoreService.filesToUpload$.subscribe((res) => {
				if (res) {
					this.files = [...res];
					this.uploadImages(res);
				}
			})
		);
	}

	ngOnInit(): void {}

	uploadImages(formData: FormData) {
		this.globalStoreService.updateListFiles$.next(false);

		if (!formData || !formData.has('files')) {
			return;
		}

		if (this.activeCompany?.uuid) {
			this.companyFilesService.postManyCompanyFiles(this.activeCompany.uuid, formData).subscribe({
				next: (event: any) => {
					if (event.type === HttpEventType.UploadProgress && event.total) {
						this.uploadProgress$.next(Math.round((100 * event.loaded) / event.total - 10));
					}
					if (((event.type = 3), event.loaded === event.total && event.body)) {
						this.uploadProgress$.next(100);
						setTimeout(() => {
							this.uploadProgress$.next(null);
							this.globalStoreService.updateListFiles$.next(true);
							this.toastService.success('toast_files_created', 'Success');
						}, 3000);
					}
				},
				error: (err) => {
					this.toastService.error('toast_files_created_error', 'Error');
					this.uploadProgress$.next(null);
				},
			});
		}
	}

	onFileSelectClick(): void {
		const fileInput = document.getElementById('fileInput') as HTMLInputElement;
		if (fileInput) {
			fileInput.click();
		}
	}

	onFilesSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		if (input.files) {
			const files = Array.from(input.files).filter((file) => ['image/jpeg', 'image/jpg', 'image/svg+xml', 'image/png'].includes(file.type));

			if (files.length > 0) {
				const formData = new FormData();
				files.forEach((file: File) => {
					formData.append('files', file);
				});

				this.uploadImages(formData);

				input.value = '';
			} else {
				this.toastService.warning('toast_files_tried_upload_not_accepted', 'Warning');
			}
		}
	}

	onClose() {
		this.files = null;
		this.uploadProgress$.next(null);
	}
}
